import { Content } from '../models/content';

export const spanishContent: Content = {
  translation: {
    title:
      'Operador de pool de staking de Cardano con sede en Europa<br /> diseñado y construido por <a href="mailto:adapool_charles@pm.me">@Charles</a> y <a href="mailto:adapool_mikael@pm.me">@Mika</a>.',
    whoAreWe: '¿Quiénes somos?',
    whyJoinUs: '¿Por qué unirse a nosotros?',
    poolDetails: 'Detalles del pool',
    s1: {
      p1: 'Somos Charles 😊 y Mika 😉, una asociación de dos emprendedores franceses motivados para democratizar el uso de las criptomonedas.',
      p2: 'Mika, que ayuda a las administraciones en sus transformaciones digitales, aporta su experiencia técnica y humana. Charles aporta más de una década de experiencia en ingeniería de software. ¡Juntos, estamos participando con entusiasmo en el desarrollo de la red Cardano!',
      p3: 'Hemos estado involucrados en las criptomonedas desde 2017, cuando tuvimos la oportunidad de obtener beneficios en la cima del mercado. Descubrimos el proyecto Cardano en ese momento y, desde entonces, lo hemos seguido con gran interés. Nuestro objetivo con ADA Pool Europe es crear una comunidad de personas que compartan nuestros valores, crean en Cardano y a la que nos gustaría ofrecer una buena experiencia de agrupación de capital.',
      p4: 'Nuestro objetivo con ADA Pool Europe es crear una comunidad de personas que compartan nuestros valores, crean en Cardano y a la que ofrecemos una buena experiencia de agrupación de capital.',
    },
    s2: {
      p1: 'Estamos motivados para democratizar el uso de las criptomonedas.',
      p2: ' infraestructura de alta disponibilidad',
      p3: ' con comisiones limitadas',
      p4: ' abierto al público más amplio posible',
      p5: ' servidores dedicados y seguros',
      p6: 'Nuestro pool de staking de Cardano con sede en Europa se dedica a fortalecer y descentralizar la red Cardano. \n Ofrecemos un staking de alta disponibilidad, fiable y seguro, basado en dos nodos de retransmisión y un nodo productor en centros de servidores de clase empresarial. Nuestro objetivo es crear una buena experiencia para el participante.',
      p7: 'Ponemos un gran énfasis en el rendimiento y la seguridad de nuestra infraestructura de pool. Nos gustaría permitir que el mayor número posible de personas participe en la aventura cripto.',
      p8: 'Al hacer staking de sus ADAs en nuestro pool, usted participa en el funcionamiento de la red Cardano.',
      p9: "✔&nbsp;Sus ADAs nunca están bloqueados, puede transferirlos en cualquier momento y sin penalización&nbsp;;<br><br> ✔&nbsp;Sus ADAs están siempre en su billetera, permanecen con usted. No puede perderlos por el método de 'staking' &nbsp;;<br><br> ✔&nbsp;Sus recompensas se reinvierten automáticamente. Cada 5 días recibe su parte de las ganancias que se acumulan automáticamente&nbsp;;<br><br> ✔&nbsp;Puede empezar a acumular sus ADA, incluso si tiene muy pocos.",
    },
    s3: {
      p1: '¡Participar en la red Cardano es fácil!<br>Solo tiene que delegar sus criptomonedas ADA en nuestro pool "adapool-europe".',
      p2: 'El identificador a introducir para delegar su ADA:',
      p3: 'Widget interactivo',
      p4: 'Pledge (Compromiso)',
      p5: 'Propietarios:',
      p6: 'Valor:',
      p7: ' Stake',
      p8: 'Delegadores:',
      p9: 'Valor:',
      p10: 'Comisiones',
      p11: 'Comisiones variables:',
      p12: 'Comisión fija:',
      p13: 'Precio de la criptomoneda',
    },
    footer: {
      p1: 'Contáctenos',
    },
  },
};
